import { getCustomWizardSelectStyles } from 'components/v2/epd-compiler-inputs/select-styles';
import { useState } from 'react';
import Select from 'react-select';
import { useTheme } from 'styled-components';
import { Theme } from 'styles/theme';
import { Option } from 'types/types';

const ProductCategorySelector = ({ label, options, handlePostChangeAction, ...props }: any) => {
  const theme = useTheme() as Theme;
  const { name, isMulti, onChange } = props;
  const [selectedValue, setSelectedValue] = useState(isMulti ? [] : '');
  const customSelectStyles = getCustomWizardSelectStyles(theme);

  const handleChange = (selectedOption: Option) => {
    const selectedValue = selectedOption ? selectedOption.value : '';
    setSelectedValue(selectedValue);
    if (handlePostChangeAction) {
      handlePostChangeAction({ target: { name: props.name, value: selectedValue } });
    }
  };

  const handleMultiChange = (selectedOptions: Option[]) => {
    const selectedValue = selectedOptions ? selectedOptions.map((i: Option) => i.value) : [];
    onChangeSelectValue(selectedValue);
  };

  const onChangeSelectValue = (value: any) => {
    const event = { target: { name, value } };
    onChange(event);
    if (handlePostChangeAction) {
      handlePostChangeAction(event);
    }
  };

  return (
    <div>
      <label htmlFor={name}>{label}</label>
      <Select
        id={name}
        options={options}
        value={options.find((option: Option) => option.value === selectedValue)}
        onChange={props.isMulti ? handleMultiChange : handleChange}
        styles={customSelectStyles}
        {...props}
      />
    </div>
  );
};

export default ProductCategorySelector;
